import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';
import { callMsGraph } from "../utils/MsGraphApiCall";
import 'bootstrap/dist/css/bootstrap.min.css';

const API_URL = 'https://nice-sky-008b0db0f.5.azurestaticapps.net/api/';
const API_KEY = '6ws67Oj0csDneKWLmQYeCwkQVy_yBg_8tN1AmcTmZM6xAzFuJwmBSw==';

const ListJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch the signed-in user's information
    const fetchUserData = async () => {
      try {
        const userData = await callMsGraph();
        setUser(userData);
      } catch (err) {
        console.error('Error fetching user data:', err);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    if (!user) return;

    const fetchJobs = async () => {
      try {
        const response = await axios.get(`${API_URL}list_jobs`, {
          headers: {
            'x-ms-sdg-unep-id': user.mail,
          },
          params: { code: API_KEY },
        });
        //console.log('Response data:', response.data);
        setJobs(response.data);
        setError('');
      } catch (err) {
        if (err.response && err.response.status === 401) {
          setError('Unauthorized access. Please log in again.');
          // Optionally, implement a logout or re-authentication flow here
        } else {
          setError('Failed to fetch jobs');
        }
        console.error('Error fetching jobs:', err.response ? err.response.data : err);
      } finally {
        setLoading(false);
      }
    };

    // Initial fetch
    fetchJobs();

    // Set up polling every 10 seconds
    const intervalId = setInterval(fetchJobs, 10000);

    // Clean up the interval on component unmount//
    return () => clearInterval(intervalId);
                }, [user]);
                const getStatus = (job) => {
                  if (job.state === 'Waiting') {
                    return 'Waiting';
                  }
                
                  if (job.state === 'Running') {
                    return 'Running';
                  }
                
                  if (job.state === 'Terminated') {
                    if (job.exit_code === 0) {
                      return 'Completed';
                    }
                
                    return 'Failed';
                  }
                
                  return job.state;
                };

  const downloadJobFile = async (jobId) => {
    try {
      const response = await axios.get(`${API_URL}download_files`, {
        headers: {
          'x-ms-sdg-unep-id': user.mail,
        },
        params: { code: API_KEY, job_id: jobId },
        responseType: 'blob',
      });
      saveAs(response.data, `job_${jobId}.zip`);
      console.log(`Downloaded job ${jobId} successfully`);
    } catch (error) {
      console.error(`Error downloading job ${jobId}:`, error);
    }
  };

  const handleDeleteJob = async (jobId) => {
    try {
      const response = await axios.delete(`${API_URL}delete_job`, {
        headers: {
          'x-ms-sdg-unep-id': user.mail,
        },
        params: { code: API_KEY, job_id: jobId },
      });

      if (response.status === 200) {
        console.log(`Deleted job ${jobId} successfully`);
        setJobs((prevJobs) => prevJobs.filter((job) => job.job_id !== jobId));
      } else {
        console.error(`Failed to delete job ${jobId}:`, response.data);
      }
    } catch (error) {
      console.error(`Error deleting job ${jobId}:`, error);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container">      
      <h3 class="text-center" style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>List of Jobs</h3>
      <table className="table table-bordered" style={{ margin: "0 auto", width: "80%" }}>
      <thead>
            <tr>
              <th>ID</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
        </thead>
          <tbody>
            {jobs.length > 0 ? (
              jobs.map((job) => {
                const status = getStatus(job);
                return (
                  <tr key={job.job_id}>
                    <td>{job.job_id}</td>
                    <td>
                      <span
                        className={`badge ${
                          status === 'Completed'
                            ? 'bg-success'
                            : status === 'Failed'
                            ? 'bg-danger'
                            : status === 'Running'
                            ? 'bg-primary'
                            : 'bg-warning text-dark'
                        }`} >
                        {status}
                      </span>
                    </td>
                    <td> 
                      <button onClick={() => handleDeleteJob(job.job_id)} className="btn btn-danger btn-sm mx-1"> Delete </button> 
                      <button onClick={() => downloadJobFile(job.job_id)} className="btn btn-primary btn-sm"> Download </button> 
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="3">No jobs available.</td>
              </tr>
            )}
          </tbody>
      </table>
    </div>
  );
};

export default ListJobs;
